// React
import { ReactElement } from 'react';
// Interfaces
import { IconsEnum } from '@utmb/types/icons';
// Design System
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
// Style
import styles from './qualifiers-stat.module.scss';

interface QualifierStatProps {
    label?: string;
    value?: string;
    isPlace?: boolean;
}

const QualifierStat = (props: QualifierStatProps): ReactElement => {
    const { label, value, isPlace } = props;

    return (
        <>
            {label && (
                <Font.OxaniumBold mobile="14" desktop="14" className={`lh-20 ${styles.city_label}`}>
                    {label}
                </Font.OxaniumBold>
            )}
            {value && (
                <Font className={`${styles.city_name}`}>
                    {isPlace && <Icon variant={IconsEnum.PIN} />}
                    {value}
                </Font>
            )}
        </>
    );
};

export default QualifierStat;
